"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _mediaQuery = _interopRequireDefault(require("../utils/mediaQuery"));
var _consts = require("../utils/mediaQuery/consts");
var _normalize = _interopRequireDefault(require("./normalize"));
const StyledBox = (0, _styledComponents.default)(({
  className,
  asComponent: Element,
  children,
  dataTest,
  id,
  forwardRef
}) => /*#__PURE__*/React.createElement(Element, {
  className: className,
  "data-test": dataTest,
  id: id,
  ref: forwardRef
}, children)).withConfig({
  displayName: "Box__StyledBox",
  componentId: "sc-bvm5o6-0"
})(["font-family:", ";box-sizing:border-box;", ""], ({
  theme
}) => theme.orbit.fontFamily, ({
  viewports
}) => {
  return Object.keys(viewports).map(query => {
    const value = viewports[query];
    if (query !== Object.values(_consts.DEVICES)[0] && typeof value !== "undefined") {
      return _mediaQuery.default[query]((0, _styledComponents.css)(["", ""], (0, _normalize.default)(value)));
    }
    return (0, _normalize.default)(value);
  });
});
StyledBox.defaultProps = {
  theme: _defaultTheme.default
};
const Box = /*#__PURE__*/React.forwardRef(({
  as = "div",
  id,
  mediumMobile,
  largeMobile,
  tablet,
  desktop,
  largeDesktop,
  children,
  dataTest,
  className,
  ...smallMobile
}, ref) => {
  const viewports = {
    smallMobile,
    mediumMobile,
    largeMobile,
    tablet,
    desktop,
    largeDesktop
  };
  return /*#__PURE__*/React.createElement(StyledBox, {
    forwardRef: ref,
    asComponent: as,
    id: id,
    dataTest: dataTest,
    className: className,
    viewports: viewports
  }, children);
});
var _default = Box;
exports.default = _default;